__turbopack_context__.v({
  "carouselWrapper": "Ql9lfq_carouselWrapper",
  "container": "Ql9lfq_container",
  "desktopHeading": "Ql9lfq_desktopHeading",
  "mobileHeading": "Ql9lfq_mobileHeading",
  "rightColumn": "Ql9lfq_rightColumn",
});
